import { Ng2StateDeclaration } from "@uirouter/angular";
import { DashboardComponent } from "./dashboard.component";

/**
 * The Dashboard state
 */
export const dashboardState: Ng2StateDeclaration = {
    name: "app.dashboard",
    url: "/dashboard",
    views: {
        "main-view@app": {
            component: DashboardComponent
        }
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/dashboard/dashboard.states.ts